import Card, { SectionTitle } from "@/components/base/Card";
import type { Activity } from "@/types";

const toneMap = {
  primary: "bg-primary-50 text-primary-700",
  accent: "bg-accent-50 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function ActivityFeed({ activities }: { activities: Activity[] }) {
  return (
    <Card>
      <SectionTitle
        icon="ri-pulse-line"
        title="Dernières activités"
        subtitle="Mouvements récents dans l'établissement"
      />
      <div className="space-y-1">
        {activities.map((act) => (
          <div key={act.id} className="flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100">
            <span className={`w-8 h-8 rounded-md flex items-center justify-center shrink-0 ${toneMap[act.tone]}`}>
              <i className={`${act.icon} text-base`}></i>
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-foreground-900">{act.title}</p>
              <p className="text-xs text-foreground-500 truncate">{act.detail}</p>
            </div>
            <span className="whitespace-nowrap text-xs text-foreground-400">{act.time}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}